import okta from '../../assets/images/sso/okta.svg';
import entra from '../../assets/images/sso/entra.svg';

const DEFAULT_ENTRA_SSO_SETTINGS = {
  provider: 'entra',
  certificate: '',
  entryPointUrl: '',
  issuerUrl: `${process.env.REACT_APP_API_HOST}saml/login/callback/entra`,
  type: 'SAML'
};

const DEFAULT_OKTA_SSO_SETTINGS = {
  provider: 'okta',
  certificate: '',
  entryPointUrl: '',
  issuerUrl: '',
  type: 'SAML'
};

export const SSO_PROVIDERS = {
  okta: {
    label: 'Okta',
    icon: okta,
    description:
      'Okta is a cloud-based identity and access management service that enables organizations to use a single sign-on (SSO) to access applications.',
    default: DEFAULT_OKTA_SSO_SETTINGS
  },
  entra: {
    label: 'Entra',
    icon: entra,
    description:
      'Microsoft Entra SSO simplifies access by enabling users to log in once and access multiple applications securely, reducing password fatigue and enhancing security across cloud and on-premises environments.',
    default: DEFAULT_ENTRA_SSO_SETTINGS
  }
};
